import { z } from "zod"
import { stringRequired } from "@/models/common"
import { Language } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChCreatePsychologicalPsychoTherapyMutation.graphql.ts"

const requiredTextField = z
  .string()
  .min(1, { message: "common.fieldErrorList.requiredField" })
  .max(1000, { message: "common.fieldErrorList.maxCharLimit" })

export const consultationReportSchema = z
  .object({
    language: z.custom<Exclude<Language, "ENGLISH">>((language) => !!language, {
      message: "common.fieldErrorList.requiredField",
    }),
    healthcareProviderId: stringRequired,
    diagnosisCode: stringRequired,
    anamnesis: requiredTextField,
    recommendedTreatment: requiredTextField,
    isAiGenerated: z.boolean(),
    isReviewed: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (data.isAiGenerated && !data.isReviewed) {
      ctx.addIssue({
        code: "custom",
        path: ["isReviewed"],
        message: "common.fieldErrorList.requiredField",
      })
    }
  })

export type ConsultationReportSchema = z.infer<typeof consultationReportSchema>

export type AiContent = Pick<ConsultationReportSchema, "anamnesis" | "recommendedTreatment">
